import { render, staticRenderFns } from "./WinningNumbersDisplay.vue?vue&type=template&id=26b22c05&scoped=true&"
import script from "./WinningNumbersDisplay.vue?vue&type=script&lang=js&"
export * from "./WinningNumbersDisplay.vue?vue&type=script&lang=js&"
import style0 from "./WinningNumbersDisplay.vue?vue&type=style&index=0&id=26b22c05&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b22c05",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
